// Make header names more readable
export const clusterHeaderMap: Record<string, string> = {
  mcap_groups: 'Market cap group',
};
